import ValidationErrorDTO from "@/models/ValidationErrorDTO";

type SymfonyLikeViolation = {
  message?: string;
  propertyPath?: string;
  property_path?: string;
  code?: string;
};

function violationPath(v: SymfonyLikeViolation): string {
  return typeof v.propertyPath === "string"
    ? v.propertyPath
    : typeof v.property_path === "string"
      ? v.property_path
      : "";
}

function isSymfonyLikeViolation(v: unknown): v is SymfonyLikeViolation {
  if (typeof v !== "object" || v === null) {
    return false;
  }
  const o = v as SymfonyLikeViolation;
  return typeof o.propertyPath === "string" || typeof o.property_path === "string";
}

function isLegacyValidationError(v: unknown): v is ValidationErrorDTO {
  return typeof v === "object" && v !== null && typeof (v as ValidationErrorDTO).field === "string";
}

export function normalizeHttpValidationErrors(data: unknown): ValidationErrorDTO[] {
  let list: unknown[] = [];
  if (Array.isArray(data)) {
    list = data;
  } else if (typeof data === "object" && data !== null) {
    const o = data as Record<string, unknown>;
    if (Array.isArray(o.violations)) {
      list = o.violations;
    } else if (Array.isArray(o.errors)) {
      list = o.errors;
    }
  }

  if (list.length === 0) {
    return [];
  }

  if (isSymfonyLikeViolation(list[0])) {
    return (list as SymfonyLikeViolation[]).map(symfonyViolationToDto);
  }

  if (isLegacyValidationError(list[0])) {
    return list as ValidationErrorDTO[];
  }

  return [];
}

function symfonyViolationToDto(v: SymfonyLikeViolation): ValidationErrorDTO {
  const path = violationPath(v);
  const message = typeof v.message === "string" ? v.message : "";
  const code =
    typeof v.code === "string" && v.code.length > 0 ? v.code : "INVALID_VALUE";
  const configKeyMatch = /^config\.(.+)$/.exec(path);
  const field =
    path === "config" ? "config" : configKeyMatch ? path : path || "config";

  return {
    field,
    message,
    code,
  };
}
